import React from 'react'
import { BarItemIdentifier } from '@mui/x-charts'

import { useDebounceFn } from '@hooks'

import { BarChartResponseType, SelectedBar } from '../../../types/api/barChart.api'

type TProps = {
  setSelectedBar: React.Dispatch<React.SetStateAction<SelectedBar>>
  diagramConfig?: BarChartResponseType
}

const useHandlers = ({ setSelectedBar, diagramConfig }: TProps) => {
  const handleBarItemClick = useDebounceFn({
    fn: (_event: React.MouseEvent<SVGElement, MouseEvent>, barItem: BarItemIdentifier) => {
      if (diagramConfig) {
        let series
        if (barItem.dataIndex !== undefined) {
          series = diagramConfig.timeline.series[barItem.dataIndex]
        } else {
          series = {
            dateRange: {
              from: diagramConfig.timeline.series[0].dateRange.from,
              till: diagramConfig.timeline.series[diagramConfig.timeline.series.length - 1]
                .dateRange.till,
            },
          }
        }
        const column = diagramConfig.columns.find(col => col.id === barItem.seriesId)
        const resource = diagramConfig.resources.find(res => res.columnId === column?.id)
        if (column && series && resource) {
          setSelectedBar({
            series,
            column,
            timeIncrement: diagramConfig.timeline.timeIncrement,
            resource,
          })
        }
      }
    },
    delay: 500,
  })

  return { handleBarItemClick }
}

export default useHandlers
